import React from 'react';
import MediumFeed from '../components/MediumFeed';
import { mediumUsername } from '../data';

const Posts = () => {
  return (
    <div className="page-content">
      <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.78rem', color: 'var(--accent)', letterSpacing: '0.08em', marginBottom: 8 }}>
        {'// WRITING'}
      </div>
      <h1 className="page-title">Posts</h1>
      <p className="page-subtitle">
        Pulled live from{' '}
        <a href={`https://medium.com/@${mediumUsername}`} target="_blank" rel="noopener noreferrer">
          medium.com/@{mediumUsername}
        </a>
        . Notes on 5G/6G, software, and AI.
      </p>
      <MediumFeed />
    </div>
  );
};

export default Posts;
